// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"83687c0c","453":"8a744724"}[chunkId] + ".chunk.js";
};